define('lib/Podio.Transport.Tasks.Create',['require','jquery','lib/Podio.Transport','lib/Podio.Routes','lib/Podio.Utils'],function (require) {

  var $ = require('jquery');
  var transport = require('lib/Podio.Transport');
  var routes = require('lib/Podio.Routes');
  var podioUtils = require('lib/Podio.Utils');

  function getCreateTaskModalLayout(taskAttributes, space_id, variant, collapsed, callback) {
    var url = routes.new_json_task_path();
    var scopedTaskAttributes = {};
    $.each(taskAttributes, function(key, value) {
      scopedTaskAttributes['task[' + key + ']'] = value;
    });
    if(podioUtils.isPresent(space_id)) {
      scopedTaskAttributes['space_id'] = space_id;
    }
    if(podioUtils.isPresent(variant)) {
      scopedTaskAttributes['variant'] = variant;
    }
    if(podioUtils.isPresent(collapsed)) {
      scopedTaskAttributes['collapsed'] = collapsed;
    }
    transport.getJSON(url, {requestData: scopedTaskAttributes}, callback);
  }

  function createTask(elmForm, callback) {
    var path = elmForm.attr('action');

    // Serialize array, temporarily enabling disabled elements to get them included
    var disabled = $('#new_task :disabled');
    disabled.prop('disabled', false);
    var requestData = elmForm.serializeArray();
    disabled.prop('disabled', true);

    transport.postJSON(path, {'requestData': requestData}, function(responseData) {
      callback(responseData);
    });
  }

  return {
    getCreateTaskModalLayout: getCreateTaskModalLayout,
    createTask: createTask
  };

});



